import types from './types';

const INITIAL_STATE = {
  isChecking: false,
  isCheckingBulk: false,
  isFetching: false,
  isFetchingNdcCode: false,
  isFetchingNdcRequiredFlag: false,

  result: [],
};

const claimNDCReducer = (state = INITIAL_STATE, action: any) => {
  switch (action.type) {

  case types.CHECK_NDC_CPT_COMPATIBILITY_REQUEST:
    return {
      ...state,
      result: [],
      isChecking: true,
    };

  case types.CHECK_NDC_CPT_COMPATIBILITY_SUCCESS:
    return {
      ...state,
      result: action.payload,
      isChecking: false,
    };

  case types.CHECK_NDC_CPT_COMPATIBILITY_FAILURE:
    return {
      ...state,
      result: [],
      isChecking: false,
    };

  case types.CHECK_BULK_NDC_CPT_COMPATIBILITY_REQUEST:
    return {
      ...state,
      result: [],
      isCheckingBulk: true,
    };

  case types.CHECK_BULK_NDC_CPT_COMPATIBILITY_SUCCESS:
    return {
      ...state,
      result: action.payload,
      isCheckingBulk: false,
    };

  case types.CHECK_BULK_NDC_CPT_COMPATIBILITY_FAILURE:
    return {
      ...state,
      result: [],
      isCheckingBulk: false,
    };

  case types.GET_RELATED_NDC_REQUEST:
    return {
      ...state,
      result: [],
      isFetching: true,
    };

  case types.GET_RELATED_NDC_SUCCESS:
    return {
      ...state,
      result: action.payload,
      isFetching: false,
    };

  case types.GET_RELATED_NDC_FAILURE:
    return {
      ...state,
      result: [],
      isFetching: false,
    };

  case types.GET_NDC_CODE_REQUEST:
    return {
      ...state,
      isFetchingNdcCode: true,
    };

  case types.GET_NDC_CODE_SUCCESS:
    return {
      ...state,
      result: action.payload,
      isFetchingNdcCode: false,
    };

  case types.GET_RELATED_NDC_FAILURE:
    return {
      ...state,
      result: [],
      isFetchingNdcCode: false,
    };

  case types.GET_NDC_REQUIRED_REQUEST:
    return {
      ...state,
      isFetchingNdcRequiredFlag: true,
    };

  case types.GET_NDC_REQUIRED_SUCCESS:
    return {
      ...state,
      result: action.payload,
      isFetchingNdcRequiredFlag: false,
    };

  case types.GET_NDC_REQUIRED_FAILURE:
    return {
      ...state,
      result: [],
      isFetchingNdcRequiredFlag: false,
    };

  default:
    return state;
  }
};

export default claimNDCReducer;
